import { useQuery } from 'react-query';
import { CUSTOMER_QUERY_KEY } from '../../constants/query';
import CustomerService from '../../services/customer.service';

const useFetchCustomer = ({ id }) =>
  useQuery(!!id && CUSTOMER_QUERY_KEY, async () => {
    if (!id) return {};
    const response = await CustomerService.getCustomer({ id });

    if (response.customer) {
      const { customer } = response;
      return {
        ...response,
        id: customer?.id,
        companyName: customer.companyName,
      };
    }

    return response;
  });

export default useFetchCustomer;
